import ToolTip from "components/design/toolTip";
import { useHasSubscriptionPermission } from "hooks/useHasSubscriptionPermission";
import { ComponentProps, ReactNode } from "react";
import { SUBSCRIPTION_PERMISSION_FEATURES } from "types/contants/subscriptionPermissionFeaturesTypes";

export type PermissionBasedViewProps = {
  children: ReactNode;
  blockedUI: ReactNode;
  feature?: SUBSCRIPTION_PERMISSION_FEATURES;
  errorMessage?: string;
  route?: string;
  product_type?: "TAX" | "BOOKS";
  entityId?: string;
  onUpgrade?: () => void;
  isNav?: boolean;
};

export const PermissionBasedView = ({
  children,
  blockedUI,
  feature,
  errorMessage,
  route,
  product_type = "BOOKS",
  entityId,
  onUpgrade,
  isNav,
  ...props
}: PermissionBasedViewProps & ComponentProps<typeof ToolTip>) => {
  const permission = useHasSubscriptionPermission({
    feature: feature,
    route,
    product_type,
    parentEntityId: entityId,
  });

  const blocked = permission?.blocked;
  const isLoading = permission?.isLoading;

  if (isNav && (!blocked || !permission)) {
    return children;
  }

  if (!blocked && !isLoading) {
    return children;
  }

  if (!permission && !isLoading) {
    return children;
  }

  return <>{blockedUI}</>;
};
